import * as React from "react";
 
// Components
import Header from "../Header";
import Footer from "../Footer";
import IndicationAndSafetyDrawer from "../IndicationAndSafety/Drawer/IndicationAndSafetyDrawer";
import IndicationAndSafety from "../IndicationAndSafety";
import WelcomeModal from "../WelcomeModal";
import ScrollToTop from "../ScrollToTop";
// Styles
import GlobalStyles from "../../styles/global";
import { StyledLayout, PageMain } from "./styles";
import PageSeo from "../Seo/PageSeo";
import { useContext } from "react";
 
import Theme from "../../util/globals/Theme";
import { SelectIndicationContextProvider } from "../../context/SelectIndicationContext";
import useWindowSize from "../../util/hooks/useWindowSize";
import MultibrandSSIPopup from "../MultibrandSSIPopup/Drawer/MultibrandSSIPopup";
 
 
const PageLayout = ({ children, location, pageMeta }) => {
  const { width } = useWindowSize();
  const isMed = width > Theme.breakpoints.lg;
  const isMob = width < Theme.breakpoints.lg;
 
  const [isHcp, setIsHcp] = React.useState(true);
 
    React.useEffect(() => {
      if (typeof window !== "undefined") {
        const value = window.localStorage.getItem("isHCP");
        setIsHcp(value === "true");
      }
    }, []);
 
    // if (isHcp === null) {
    //   return null; // or <div>Loading...</div>
    // }
 
  let pageKey = "default";
  switch (location.pathname.split("/")[1].toLowerCase()) {
    case "von-hippel-lindau":
      pageKey = "vhl";
      break;
    case "advanced-renal-cell-carcinoma":
    case "component-examples":
      pageKey = "rcc";
      break;
    case "":
      pageKey = "mt";
      break;
    case "contact-us":
      pageKey = "ut";
      break;
    case "404":
    case "site-map":
      pageKey = "ut";
      break;
  }
 
  return (
    <SelectIndicationContextProvider>
      <StyledLayout>
       
     {!isHcp && <WelcomeModal />}
        <PageSeo pageMeta={pageMeta} />
        <GlobalStyles />
 
        <Header
          pageKey={pageKey}
          location={location}
          isMed={isMed}
          isMob={isMob}
        />
        <IndicationAndSafetyDrawer location={location} />
        <MultibrandSSIPopup location={location} />
        <PageMain>{children}</PageMain>
        <IndicationAndSafety />
 
        <ScrollToTop />
 
        <Footer pageKey={pageKey} />
 
       
      </StyledLayout>
    </SelectIndicationContextProvider>
  );
};
 
export default PageLayout;